import {
  DEFAULT_FANFICS_CATALOG_SORT,
  FANFICS_CATALOG_SORT_VALUES,
  type FanficsCatalogSortBy,
} from '@/lib/fanfics-catalog-api';

export const isValidFanficsCatalogSort = (value: string): value is FanficsCatalogSortBy =>
  FANFICS_CATALOG_SORT_VALUES.includes(value as FanficsCatalogSortBy);

export const resolvePermalinkSort = (
  rawSort: string | string[] | undefined,
): FanficsCatalogSortBy => {
  const sortValue = typeof rawSort === 'string' ? rawSort : DEFAULT_FANFICS_CATALOG_SORT;
  return isValidFanficsCatalogSort(sortValue) ? sortValue : DEFAULT_FANFICS_CATALOG_SORT;
};
